import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Object$assign from 'babel-runtime/core-js/object/assign';

/* eslint-disable max-lines */
import search from '@/components/Search';
import { fetchDemoCategory, createDemoItem, updateDemoItem, deleteDemoItem, fetchDemoList, hideDemoList } from '@/api/manage';
import deleteBtn from '@/components/DeleteBtn';
import baseSelect from './baseSelect';
import { uploadIcon, getUrlIcon } from '@/api/common/index.js';
import _ from 'lodash';

export default {
  components: { deleteBtn: deleteBtn, baseSelect: baseSelect, search: search },
  data: function data() {
    return {
      searchParams: {},
      searchProp: {
        demoCid: true,
        keyword: true,
        defaultKey: 'title',
        searchField: [{
          id: 'title',
          name: '按名称'
        }]
      },
      typeOptions: [],
      type: '',
      list: null,
      listLoading: true,
      page: 1,
      page_size: 15,
      total: 1,
      dialogVisible: false,
      dialog: {
        title: '上传素材',
        loading: false,
        platformOptions: [{
          id: 'ios',
          name: 'iOS'
        }, {
          id: 'android',
          name: 'Android'
        }],
        orientationOptions: [{
          id: 1,
          name: '横屏'
        }, {
          id: 2,
          name: '竖屏'
        }, {
          id: 3,
          name: '自适应'
        }],
        appFileList: [],
        fileList: [],
        videoList: [],
        coverImageList: [],
        oldData: {},
        poster: '1',
        basicType: '1',
        data: {
          app_url: '',
          id: '',
          title: '',
          platform: 'ios',
          description: '',
          category_id: '',
          icon_file: '',
          zip_file: '',
          video_file: '',
          sort_id: '0',
          orientation: 3,
          image_file: '',
          basic_id: ''
        }
      },
      dialogRule: {
        basic_id: [{ required: true, message: '请选择基础包', trigger: 'change' }],
        app_url: [{ required: true, message: '请输入应用商店地址', trigger: 'blur' }],
        title: [{ required: true, message: '请填写素材名称', trigger: 'blur' }],
        platform: [{ required: true, message: '请选择平台', trigger: 'change' }],
        description: [{ required: true, message: '请填写描述', trigger: 'blur' }],
        category_id: [{ required: true, message: '请选择分类', trigger: 'change' }],
        icon_file: [{ required: true, message: '请上传素材图标', trigger: 'change' }],
        zip_file: [{ required: true, message: '请上传zip文件', trigger: 'change' }],
        video_file: [{ required: true, message: '请上传视频文件', trigger: 'change' }],
        image_file: [{ required: false, message: '请上传封面图片', trigger: 'change' }],
        orientation: [{ required: true, message: '请选择展示方向', trigger: 'blur' }]
      }
    };
  },

  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        if (this.$refs.dialog) {
          this.$refs.dialog.clearValidate();
          this.dialog.appFileList = [];
          this.dialog.fileList = [];
          this.dialog.videoList = [];
          this.dialog.data.app_url = '';
          this.dialog.data.basic_id = '';
          this.dialog.basicType = '1';
          this.dialog.poster = '1';
          this.dialog.data.title = '';
          this.dialog.data.platform = 'ios';
          this.dialog.data.description = '';
          this.dialog.data.category_id = '';
          this.dialog.data.icon_file = '';
          this.dialog.data.zip_file = '';
          this.dialog.data.video_file = '';
          this.dialog.data.orientation = 3;
          this.dialog.data.sort_id = '0';
          this.dialog.data.image_file = '';
          this.dialog.coverImageList = [];
        }
      }
    },
    'dialog.data.app_url': function dialogDataApp_url(val) {
      var _this = this;

      if (val) {
        if (val.indexOf('itunes') !== -1) {
          this.dialog.data.platform = 'ios';
        } else if (val.indexOf('google') !== -1) {
          this.dialog.data.platform = 'android';
        }
        getUrlIcon({
          app_url: val
        }).then(function (res) {
          var dataInfo = _.get(res, 'data.data.info');
          if (dataInfo && dataInfo.app_icon) {
            _this.dialog.appFileList = [{
              url: dataInfo.app_icon,
              name: 'name'
            }];
            _this.dialog.data.title = dataInfo.name;
            uploadIcon({
              url: dataInfo.app_icon
            }).then(function (re) {
              if (re.data.data.file_path) {
                _this.dialog.data.icon_file = re.data.data.file_path;
              } else {
                _this.dialog.appFileList = [];
                _this.$message({
                  message: '系统抓取到的图标上传失败，请手动上传',
                  type: 'warning'
                });
              }
            });
          } else {
            _this.$message({
              message: '系统抓取不到图标，请手动上传',
              type: 'warning'
            });
          }
        });
      }
    },
    'dialog.poster': function dialogPoster(val) {
      if (val === '1') {
        delete this.dialogRule.image_file;
        this.dialogRule.video_file = [{ required: true, message: '请上传视频文件', trigger: 'change' }];
      } else {
        delete this.dialogRule.video_file;
        this.dialogRule.image_file = [{ required: true, message: '请上传封面图片', trigger: 'change' }];
      }
    }
  },
  computed: {
    uploadUrl: {
      get: function get() {
        return process.env.BASE_API + 'common/upload/zip';
      }
    },
    uploadIconUrl: {
      get: function get() {
        return process.env.BASE_API + 'common/upload/icon';
      }
    },
    uploadVideoUrl: {
      get: function get() {
        return process.env.BASE_API + 'common/upload/file';
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (!this.typeOptions.length) {
      fetchDemoCategory().then(function (res) {
        _this2.typeOptions = res.data.data.categories;
        _this2.renderList();
      }).catch(function () {
        _this2.renderList();
      });
    }
  },

  methods: {
    renderList: function renderList(data) {
      var _this3 = this;

      var oTemp = _Object$assign({}, this.searchParams, { page: this.page });
      this.listLoading = true;
      fetchDemoList(oTemp).then(function (res) {
        _this3.listLoading = false;
        _this3.list = res.data.data.list;
        _this3.page_size = res.data.data.page_size;
        _this3.total = res.data.data.total;
      });
    },
    parseType: function parseType(string) {
      return this.typeOptions.find(function (e) {
        return Number(e.id) === Number(string);
      }).name;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.renderList();
    },
    handleSearch: function handleSearch(params) {
      this.searchParams = params;
      this.page = 1;
      this.renderList();
    },
    fnReset: function fnReset() {
      this.page = 1;
      this.type = '';
      this.renderList();
    },
    fnDeleteItem: function fnDeleteItem(obj) {
      var _this4 = this;

      this.listLoading = true;
      deleteDemoItem({
        id: obj.id
      }).then(function (res) {
        _this4.$message({
          message: '删除成功',
          type: 'success'
        });
        _this4.page = 1;
        _this4.renderList();
      }).catch(function () {
        _this4.listLoading = false;
      });
    },
    fnEditItem: function fnEditItem(obj) {
      var _this5 = this;

      this.dialog.title = '编辑素材';
      this.dialogVisible = true;

      function getName(string) {
        var aArray = string.split('/');
        if (aArray.length) {
          return aArray[aArray.length - 1];
        }
        return '';
      }

      setTimeout(function () {
        _this5.dialog.data.id = obj.id;
        _this5.dialog.appFileList = [{
          url: obj.icon_url,
          name: getName(obj.icon_url)
        }];
        _this5.dialog.fileList = [{
          url: obj.html_url,
          name: getName(obj.html_url)
        }];
        if (obj.video_url) {
          _this5.dialog.videoList = [{
            url: obj.video_url,
            name: getName(obj.video_url)
          }];
        }
        if (obj.image_url) {
          _this5.dialog.coverImageList = [{
            url: obj.image_url,
            name: getName(obj.image_url)
          }];
        }
        _this5.dialog.poster = _this5.dialog.coverImageList.length > 0 ? '2' : '1';
        _this5.dialog.basicType = Number(obj.basic_id) === 0 ? '2' : '1';
        _this5.dialog.data.title = obj.title;
        _this5.dialog.data.app_url = obj.app_url;
        _this5.dialog.data.platform = obj.platform;
        _this5.dialog.data.basic_id = String(obj.basic_id);
        _this5.dialog.data.description = obj.description;
        _this5.dialog.data.category_id = Number(obj.category_id);
        _this5.dialog.data.icon_file = obj.icon_url;
        _this5.dialog.data.zip_file = obj.html_url;
        _this5.dialog.data.video_file = obj.video_url;
        _this5.dialog.data.image_file = obj.image_url;
        _this5.dialog.data.sort_id = obj.sort_id;
        _this5.dialog.data.orientation = Number(obj.orientation);
        _this5.dialog.oldData = JSON.parse(_JSON$stringify(_this5.dialog.data));
        if (_this5.dialog.data.basic_id) {
          _this5.$refs.baseSelectComponent.remoteBase(_this5.dialog.data.basic_id);
        }
      });
    },
    fnChangeHide: function fnChangeHide(obj) {
      var _this6 = this;

      this.listLoading = true;
      hideDemoList({
        id: obj.id,
        val: Number(obj.hidden) === 1 ? 0 : 1
      }).then(function (res) {
        _this6.$message({
          message: '操作成功',
          type: 'success'
        });
        _this6.page = 1;
        _this6.renderList();
      }).catch(function () {
        _this6.listLoading = false;
      });
    },
    fnSubmit: function fnSubmit() {
      var _this7 = this;

      var submitPromise = void 0;
      var oTemp = JSON.parse(_JSON$stringify(this.dialog.data));
      if (this.dialog.title === '上传素材') {
        submitPromise = createDemoItem;
        delete oTemp.id;
      } else {
        submitPromise = updateDemoItem;
        for (var i in oTemp) {
          if (i !== 'id' && oTemp[i] === this.dialog.oldData[i]) {
            delete oTemp[i];
          }
        }
      }
      if (Number(this.dialog.basicType) === 1) {
        delete oTemp.zip_file;
      } else {
        delete oTemp.basic_id;
      }

      this.$refs.dialog.validate(function (valid) {
        if (valid) {
          _this7.dialog.loading = true;
          submitPromise(oTemp).then(function () {
            _this7.dialog.loading = false;
            _this7.dialogVisible = false;
            _this7.$message({
              message: _this7.dialog.title === '上传素材' ? '提交成功' : '修改成功',
              type: 'success'
            });
            _this7.page = 1;
            _this7.renderList();
          }).catch(function () {
            _this7.dialog.loading = false;
          });
        }
      });
    },
    fnCreateNew: function fnCreateNew() {
      this.dialog.title = '上传素材';
      this.dialogVisible = true;
    },
    beforeUpload: function beforeUpload(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    uploadIconSuccess: function uploadIconSuccess(response, file, fileList) {
      var _this8 = this;

      if (response.code === 0) {
        this.dialog.data.icon_file = response.data.file_path;
      } else {
        this.promptWhenUploadFail(response.msg);
        setTimeout(function () {
          _this8.dialog.data.icon_file = '';
          _this8.dialog.appFileList = [];
        });
      }
    },
    uploadVideoSuccess: function uploadVideoSuccess(response, file, fileList) {
      var _this9 = this;

      if (response.code === 0) {
        this.dialog.data.video_file = response.data.url;
        this.resetCoverImageFile();
        delete this.dialog.data.image_file;
      } else {
        this.promptWhenUploadFail(response.msg);
        setTimeout(function () {
          _this9.resetVideoFile();
        });
      }
    },
    uploadCoverImageSuccess: function uploadCoverImageSuccess(response, file, fileList) {
      var _this10 = this;

      if (response.code === 0) {
        this.dialog.data.image_file = response.data.file_path;
        this.resetVideoFile();
        delete this.dialog.data.video_file;
      } else {
        this.promptWhenUploadFail(response.msg);
        setTimeout(function () {
          _this10.resetCoverImageFile();
        });
      }
    },
    resetVideoFile: function resetVideoFile() {
      this.dialog.videoList = [];
      this.dialog.data.video_file = '';
    },
    resetCoverImageFile: function resetCoverImageFile() {
      this.dialog.coverImageList = [];
      this.dialog.data.image_file = '';
    },
    resetIcon: function resetIcon() {
      this.dialog.appFileList = [];
      this.dialog.data.icon_file = '';
    },
    resetZip: function resetZip() {
      this.dialog.fileList = [];
      this.dialog.data.zip_file = '';
    },
    promptWhenUploadFail: function promptWhenUploadFail(msg) {
      this.$message({
        message: msg || '上传失败，请重新尝试',
        type: 'warning'
      });
    },
    removeCoverImage: function removeCoverImage() {
      this.resetCoverImageFile();
    },
    removeVideo: function removeVideo() {
      this.resetVideoFile();
    },
    removeIcon: function removeIcon() {
      this.resetIcon();
    },
    removeZip: function removeZip() {
      this.resetZip();
    },
    uploadZipSuccess: function uploadZipSuccess(response, file, fileList) {
      var _this11 = this;

      if (response.code === 0) {
        this.dialog.data.zip_file = response.data.file_path;
      } else {
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
        setTimeout(function () {
          _this11.dialog.fileList = [];
          _this11.dialog.data.zip_file = '';
        });
      }
    },
    uploadExceed: function uploadExceed() {
      this.$message({
        message: '最多只能上传一个文件，请删除列表中的文件再进行上传操作',
        type: 'warning'
      });
    },
    fnRenderHeader: function fnRenderHeader() {
      var h = this.$createElement;

      return h(
        'span',
        null,
        ['\u6392\u5E8F\u4F18\u5148\u7EA7', ' ', h(
          'el-tooltip',
          {
            attrs: { placement: 'top', effect: 'light' }
          },
          [h(
            'div',
            { slot: 'content' },
            ['\u6570\u503C\u8D8A\u5927\uFF0C\u6392\u5E8F\u8D8A\u524D']
          ), h(
            'i',
            { 'class': 'el-icon-info text-danger' },
            []
          )]
        )]
      );
    },
    baseChange: function baseChange(id) {
      this.dialog.data.basic_id = id;
    }
  }
};